import UserManager from '../../userManager';

export const SilentRenewCallback = () => {
	
	UserManager.signinSilentCallback();

	return null;
}
